import * as en from '~/languages/en';

export function useLanguage() {
  const languages = {
    en: en,
  };

  function getTranslation(language: string = 'en') {
    // @ts-expect-error languages without type
    return languages[language];
  }

  return {
    languages,
    getTranslation,
  };
}
